import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hs-template',
    templateUrl: 'hs-template.html',
    providers: []
})
export class HsTemplate {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('first') first: boolean;
    @Input('index') index: number;

    constructor(public element: ElementRef) {

    }

    ngOnInit() {

        //ADD-contructor: private renderer: Renderer2
        //
        //this.renderer.addClass(this.element.nativeElement, 'display-block');
        // this.renderer.addClass(this.element.nativeElement, 'centro-1300');

    }

    getArray(): any[] {

        let result: any[] = [];

        let array = (this.hpage.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Array || []);

        if (this.first) {
            array.forEach((grouped, indexGroup) => result.push(grouped.Array[0]));
        }

        if (!this.first) {

            array[this.index].Array.forEach((blocked, indexBlock) => {
                if (indexBlock > 0) result.push(blocked);
            });

        }

        return result;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hs-template/hs-template.ts